/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Signed_Out_SubInputs */

const th_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อดูข้อมูลของคุณ`)
};

const en_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to see what is yours.`)
};

const ja_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインすると、あなたに関する情報が表示されます。`)
};

const zh_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后可查看属于你的内容。`)
};

const es_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para ver lo que es tuyo.`)
};

const pt_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para ver o que é seu.`)
};

const id_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk melihat apa yang jadi milik Anda.`)
};

const fr_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour voir ce qui est à vous.`)
};

const tl_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in para makita ang sa iyo.`)
};

const vi_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để xem những gì thuộc về bạn.`)
};

const ko_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 것을 보려면 로그인하세요.`)
};

const de_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um zu sehen, was dir gehört.`)
};

const ru_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы увидеть, что принадлежит вам.`)
};

const tr_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size ait olanı görmek için giriş yapın.`)
};

const it_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per vedere ciò che è tuo.`)
};

const pl_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby zobaczyć, co należy do ciebie.`)
};

const uk_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть, щоб побачити, що належить вам.`)
};

const hi_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जो आपका है उसे देखने के लिए साइन इन करें।`)
};

const ar_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لترى ما يخصّك.`)
};

const ms_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk melihat apa yang menjadi milik anda.`)
};

const bn_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী আপনার তা দেখতে সাইন ইন করুন।`)
};

const zh_tw2_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看屬於你的內容。`)
};

const zh_hk2_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看屬於你的內容。`)
};

const ur_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جو آپ کا ہے وہ دیکھنے کے لیے سائن اِن کریں۔`)
};

const fa_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای دیدن آنچه از آنِ شماست وارد شوید.`)
};

const sw_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kuona kilicho chako.`)
};

const nl_profile_signed_out_sub = /** @type {(inputs: Profile_Signed_Out_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om te zien wat van jou is.`)
};

/**
* | output |
* | --- |
* | "Sign in to see what is yours." |
*
* @param {Profile_Signed_Out_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const profile_signed_out_sub = /** @type {((inputs?: Profile_Signed_Out_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Signed_Out_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_profile_signed_out_sub(inputs)
	if (locale === "ja") return ja_profile_signed_out_sub(inputs)
	if (locale === "zh") return zh_profile_signed_out_sub(inputs)
	if (locale === "es") return es_profile_signed_out_sub(inputs)
	if (locale === "pt") return pt_profile_signed_out_sub(inputs)
	if (locale === "id") return id_profile_signed_out_sub(inputs)
	if (locale === "fr") return fr_profile_signed_out_sub(inputs)
	if (locale === "tl") return tl_profile_signed_out_sub(inputs)
	if (locale === "vi") return vi_profile_signed_out_sub(inputs)
	if (locale === "ko") return ko_profile_signed_out_sub(inputs)
	if (locale === "de") return de_profile_signed_out_sub(inputs)
	if (locale === "ru") return ru_profile_signed_out_sub(inputs)
	if (locale === "tr") return tr_profile_signed_out_sub(inputs)
	if (locale === "it") return it_profile_signed_out_sub(inputs)
	if (locale === "pl") return pl_profile_signed_out_sub(inputs)
	if (locale === "uk") return uk_profile_signed_out_sub(inputs)
	if (locale === "hi") return hi_profile_signed_out_sub(inputs)
	if (locale === "ar") return ar_profile_signed_out_sub(inputs)
	if (locale === "ms") return ms_profile_signed_out_sub(inputs)
	if (locale === "bn") return bn_profile_signed_out_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_profile_signed_out_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_profile_signed_out_sub(inputs)
	if (locale === "ur") return ur_profile_signed_out_sub(inputs)
	if (locale === "fa") return fa_profile_signed_out_sub(inputs)
	if (locale === "sw") return sw_profile_signed_out_sub(inputs)
	if (locale === "nl") return nl_profile_signed_out_sub(inputs)
	return en_profile_signed_out_sub(inputs)
});